import { createSelector } from 'reselect';

import { getListingsBenchmarkReducer } from '../selectors';

export const selectPreviouslySelectedDate = createSelector(
  [getListingsBenchmarkReducer],
  ({ previouslySelectedDate }) => previouslySelectedDate,
);

export const selectPreviouslySelectedTimeDivision = createSelector(
  [getListingsBenchmarkReducer],
  ({ previouslySelectedTimeDivision }) => previouslySelectedTimeDivision,
);
